module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAgBAMAAACbaIdJAAAAAXNSR0IB2cksfwAAABVQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAEgEApAAAAAd0Uk5TAFDP/9/g0LLSyGEAAABKSURBVHicYxAyRgOODCDgjC5sBBYORhc2AwuLoQsHMowcgBGCkFDECEFIKGKEICQUMUJwJIUiUgg6IgkjBZURdmEzJGGkEEQKNwBmaCnhyVgiPQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/content-view--header--toggle-menu@2x.png
// module id = 804
// module chunks = 0